import { Instagram, Mail } from "lucide-react";
import { T } from "@/site/Editable";
import { PageHead } from "@/site/pages/About";
import { InquiryForm } from "@/site/InquiryForm";
import { INSTAGRAM, STUDIO_EMAIL } from "@/site/SiteLayout";

export default function Contact() {
  return (
    <>
      <PageHead titleKey="contact.heading" introKey="contact.intro" />
      <section className="hs-cream hs-contact" data-testid="contact-page">
        <div className="hs-wrap hs-contact__grid">
          <aside className="hs-contact__info hs-fade">
            <p className="hs-eyebrow hs-eyebrow--dark">Write to us</p>
            <a href={`mailto:${STUDIO_EMAIL}`} className="hs-contact__email" data-testid="contact-email-link"><Mail size={16} strokeWidth={1.25} /> {STUDIO_EMAIL}</a>
            <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" className="hs-contact__ig" data-testid="contact-instagram-link"><Instagram size={16} strokeWidth={1.25} /> @haus.a.interiors</a>
            <T k="contact.studio" className="hs-contact__studio" />
          </aside>
          <InquiryForm />
        </div>
      </section>
    </>
  );
}
